import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'productTaskTypeDescriptionPipe' })
export class ProductTaskTypeDescriptionPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    switch (value) {
      case 'story':
        return 'Nueva funcionalidad que tiene un actor que realizada una acción como formato de oración';
      case 'task':
        return 'Pequeña funcionalidad o tarea a realizar, después de implementar la funcionalidad principal';
      case 'issue':
        return 'Tarea para arreglar un error de cualquier tipo';
      default:
        return '';
    }
  }
}
